<!-- Unified Customer Form Template -->
<div class="customer-dialog-container">
  <p-dialog [(visible)]="display" [style]="{width: '90%', maxWidth: '900px'}" [modal]="true" [draggable]="false"
    [resizable]="false" header="{{isEditMode ? 'Edit Customer' : 'Add New Customer'}}" styleClass="customer-dialog"
    [dismissableMask]="true">

    <form [formGroup]="customerForm" (ngSubmit)="onSubmit()" class="unified-form">
      <!-- Customer Details Section -->
      <div class="form-section customer-details-section">
        <h3 class="section-title">Customer Details</h3>
        <div formGroupName="customerDetails" class="p-fluid">
          <div class="field">
            <label for="customerName">Customer Name*</label>
            <input id="customerName" type="text" pInputText formControlName="customerName"
              [ngClass]="{'ng-invalid ng-dirty': customerForm.get('customerDetails.customerName')?.invalid && customerForm.get('customerDetails.customerName')?.touched}">
            <small
              *ngIf="customerForm.get('customerDetails.customerName')?.invalid && customerForm.get('customerDetails.customerName')?.touched"
              class="p-error">Customer name is required</small>
          </div>
          <div class="field">
            <label for="customerAddress">Customer Address*</label>
            <textarea id="customerAddress" pInputTextarea formControlName="customerAddress" [rows]="3"
              [ngClass]="{'ng-invalid ng-dirty': customerForm.get('customerDetails.customerAddress')?.invalid && customerForm.get('customerDetails.customerAddress')?.touched}"></textarea>
            <small
              *ngIf="customerForm.get('customerDetails.customerAddress')?.invalid && customerForm.get('customerDetails.customerAddress')?.touched"
              class="p-error">Customer address is required</small>
          </div>
          <div class="field">
            <label for="customerFax">Customer Fax*</label>
            <p-inputMask id="customerFax" mask="(999) 999-9999" formControlName="customerFax"
              [ngClass]="{'ng-invalid ng-dirty': customerForm.get('customerDetails.customerFax')?.invalid && customerForm.get('customerDetails.customerFax')?.touched}"></p-inputMask>
            <small
              *ngIf="customerForm.get('customerDetails.customerFax')?.invalid && customerForm.get('customerDetails.customerFax')?.touched"
              class="p-error">Customer fax is required</small>
          </div>
        </div>
      </div>

      <!-- Contact Person Section -->
      <div class="form-section contact-person-section">
        <h3 class="section-title">Contact Person</h3>
        <div formGroupName="contactPerson" class="p-fluid">
          <div class="field">
            <label for="contactPersonName">Contact Person Name*</label>
            <input id="contactPersonName" type="text" pInputText formControlName="contactPersonName"
              [ngClass]="{'ng-invalid ng-dirty': customerForm.get('contactPerson.contactPersonName')?.invalid && customerForm.get('contactPerson.contactPersonName')?.touched}">
            <small
              *ngIf="customerForm.get('contactPerson.contactPersonName')?.invalid && customerForm.get('contactPerson.contactPersonName')?.touched"
              class="p-error">Contact person name is required</small>
          </div>
          <div class="field">
            <label for="contactPersonEmail">Contact Person Email*</label>
            <input id="contactPersonEmail" type="email" pInputText formControlName="contactPersonEmail"
              [ngClass]="{'ng-invalid ng-dirty': customerForm.get('contactPerson.contactPersonEmail')?.invalid && customerForm.get('contactPerson.contactPersonEmail')?.touched}">
            <small
              *ngIf="customerForm.get('contactPerson.contactPersonEmail')?.invalid && customerForm.get('contactPerson.contactPersonEmail')?.touched"
              class="p-error">
              <span *ngIf="customerForm.get('contactPerson.contactPersonEmail')?.errors?.['required']">Email is
                required</span>
              <span *ngIf="customerForm.get('contactPerson.contactPersonEmail')?.errors?.['email']">Please enter a valid
                email</span>
            </small>
          </div>
        </div>
      </div>

      <!-- Status Section -->
      <div class="form-section status-section">
        <h3 class="section-title">Customer Status</h3>
        <div class="p-fluid">
          <div class="field">
            <label for="status">Customer Status*</label>
            <p-dropdown id="status" [options]="statusOptions" optionLabel="label" optionValue="value"
              formControlName="status" placeholder="Select a status"
              [ngClass]="{'ng-invalid ng-dirty': customerForm.get('status')?.invalid && customerForm.get('status')?.touched}">
            </p-dropdown>
            <small *ngIf="customerForm.get('status')?.invalid && customerForm.get('status')?.touched"
              class="p-error">Status is required</small>
          </div>
        </div>
      </div>

      <!-- Shipping Details Section -->
      <div class="form-section shipping-details-section">
        <h3 class="section-title">Shipping Details</h3>
        <div class="shipping-container">
          <!-- Shipping Address List -->
          <div class="shipping-address-list" *ngIf="shippingDetails.length > 0 && !isAdding && !isEditing">
            <div class="shipping-actions">
              <button pButton icon="pi pi-plus" label="Add Address" class="p-button-success"
                (click)="addShippingDetail()"></button>
            </div>

            <p-scrollPanel [style]="{width: '100%', height: '300px'}" styleClass="shipping-scroll">
              <ng-container *ngFor="let shipping of shippingDetails.controls; let i = index">
                <div [formGroup]="shipping" class="shipping-address-card"
                  [ngClass]="{'selected': i === selectedShippingIndex}">
                  <div class="card-header">
                    <div class="company-name">
                      {{ shipping.get('companyName')?.value }}
                      <span class="default-badge" *ngIf="i === selectedShippingIndex">Default</span>
                    </div>
                    <div class="card-actions">
                      <button pButton type="button" icon="pi pi-pencil"
                        class="p-button-rounded p-button-text p-button-info" (click)="editShippingDetail(i)"></button>
                      <button pButton type="button" icon="pi pi-trash"
                        class="p-button-rounded p-button-text p-button-danger" (click)="removeShippingDetail(i)"
                        [disabled]="shippingDetails.length <= 1"></button>
                    </div>
                  </div>

                  <div class="card-body">
                    <div class="address-line">{{ shipping.get('shippingAddress')?.value }}</div>
                    <div class="address-line">{{ shipping.get('street')?.value }}</div>
                    <div class="address-line">{{ shipping.get('postalCode')?.value }}, {{ shipping.get('country')?.value
                      }}</div>
                    <div class="address-line">Fax: {{ shipping.get('fax')?.value }}</div>
                  </div>

                  <div class="card-footer">
                    <div class="p-field-radiobutton">
                      <p-radioButton [value]="shipping.get('shippingID')!.value" name="isSelectedShipping"
                        formControlName="isSelectedShipping"
                        (onClick)="setDefaultShipping(shipping.get('shippingID')!.value)" [inputId]="'shipping_' + i">
                      </p-radioButton>
                      <label [for]="'shipping_' + i">Set as default shipping address</label>
                    </div>
                  </div>
                </div>
              </ng-container>
            </p-scrollPanel>
          </div>

          <!-- Empty State - No Shipping Addresses Yet -->
          <div class="empty-state" *ngIf="shippingDetails.length === 0 && !isAdding">
            <div class="empty-icon">
              <i class="pi pi-map-marker" style="font-size: 3rem"></i>
            </div>
            <h3>No Shipping Addresses</h3>
            <p>Add your first shipping address to get started.</p>
            <button pButton type="button" icon="pi pi-plus" label="Add Address" class="p-button-success"
              (click)="addShippingDetail()"></button>
          </div>

          <!-- Add/Edit Shipping Form -->
          <div class="shipping-form-container" *ngIf="isAdding || isEditing" [@formAnimation]>
            <h3>{{ isEditing ? 'Edit Shipping Address' : 'Add New Shipping Address' }}</h3>

            <form [formGroup]="tempShippingForm" class="p-fluid">
              <div class="shipping-form-grid">
                <div class="field">
                  <label for="companyName">Company Name*</label>
                  <input id="companyName" type="text" pInputText formControlName="companyName"
                    [ngClass]="{'ng-invalid ng-dirty': tempShippingForm.get('companyName')?.invalid && tempShippingForm.get('companyName')?.touched}">
                  <small
                    *ngIf="tempShippingForm.get('companyName')?.invalid && tempShippingForm.get('companyName')?.touched"
                    class="p-error">Company name is required</small>
                </div>

                <div class="field">
                  <label for="shippingAddress">Address Line 1*</label>
                  <input id="shippingAddress" type="text" pInputText formControlName="shippingAddress"
                    [ngClass]="{'ng-invalid ng-dirty': tempShippingForm.get('shippingAddress')?.invalid && tempShippingForm.get('shippingAddress')?.touched}">
                  <small
                    *ngIf="tempShippingForm.get('shippingAddress')?.invalid && tempShippingForm.get('shippingAddress')?.touched"
                    class="p-error">Address is required</small>
                </div>

                <div class="field">
                  <label for="street">Address Line 2 (Street)*</label>
                  <input id="street" type="text" pInputText formControlName="street"
                    [ngClass]="{'ng-invalid ng-dirty': tempShippingForm.get('street')?.invalid && tempShippingForm.get('street')?.touched}">
                  <small *ngIf="tempShippingForm.get('street')?.invalid && tempShippingForm.get('street')?.touched"
                    class="p-error">Street is required</small>
                </div>

                <div class="field">
                  <label for="postalCode">Postal Code*</label>
                  <input id="postalCode" type="text" pInputText formControlName="postalCode"
                    [ngClass]="{'ng-invalid ng-dirty': tempShippingForm.get('postalCode')?.invalid && tempShippingForm.get('postalCode')?.touched}">
                  <small
                    *ngIf="tempShippingForm.get('postalCode')?.invalid && tempShippingForm.get('postalCode')?.touched"
                    class="p-error">Postal code is required</small>
                </div>

                <div class="field">
                  <label for="country">Country*</label>
                  <input id="country" type="text" pInputText formControlName="country"
                    [ngClass]="{'ng-invalid ng-dirty': tempShippingForm.get('country')?.invalid && tempShippingForm.get('country')?.touched}">
                  <small *ngIf="tempShippingForm.get('country')?.invalid && tempShippingForm.get('country')?.touched"
                    class="p-error">Country is required</small>
                </div>

                <div class="field">
                  <label for="fax">Fax*</label>
                  <p-inputMask id="fax" mask="(999) 999-9999" formControlName="fax"
                    [ngClass]="{'ng-invalid ng-dirty': tempShippingForm.get('fax')?.invalid && tempShippingForm.get('fax')?.touched}"></p-inputMask>
                  <small *ngIf="tempShippingForm.get('fax')?.invalid && tempShippingForm.get('fax')?.touched"
                    class="p-error">Fax is required</small>
                </div>
              </div>

              <div class="field-checkbox">
                <p-checkbox formControlName="isSelectedShipping" [binary]="true" inputId="isDefaultShipping">
                </p-checkbox>
                <label for="isDefaultShipping">Set as default shipping address</label>
              </div>

              <div class="shipping-form-actions">
                <button pButton type="button" icon="pi pi-times" label="Cancel" class="p-button-text"
                  (click)="cancelShippingForm()"></button>
                <button pButton type="button" icon="pi pi-check" label="Save" class="p-button-success"
                  [disabled]="tempShippingForm.invalid" (click)="saveShippingDetail()"></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <button pButton type="button" icon="pi pi-times" label="Cancel" class="p-button-text"
        (click)="onCancel()"></button>
      <button pButton type="button" icon="pi pi-check" label="Save" class="p-button-success"
        [disabled]="customerForm.invalid || shippingDetails.length === 0" (click)="onSubmit()"></button>
    </ng-template>
  </p-dialog>
</div>

<!-- Toast for notifications -->
<p-toast></p-toast>